'use client';
import type { FC } from 'react';
import { Progress } from '@/app/components/ui/progress';
import { useTaskProgress } from '../hooks/use-task-progress';

interface CustomProgressProps {
  // 存储在 localStorage 中的 id
  id: string;
  // 是否完成，如果完成，进度条会直接到 100%
  hasFinished?: boolean;
  // 预计总等待时间，单位为秒
  allWaitTime: number;
  // 进度条到多少时停止，数值范围为 0-100，默认为 100，即进度条数值走到 100 时停止
  stopProgress?: number;
}

export const CustomProgress: FC<CustomProgressProps> = ({ hasFinished, id, allWaitTime, stopProgress = 100 }) => {
  const { progress } = useTaskProgress({
    id,
    hasFinished,
    allWaitTime,
    stopProgress,
  });

  return <Progress value={progress} />;
};
